export default "__VITE_ASSET__DStEQRrf__"